import L, { LeafletEventHandlerFnMap } from 'leaflet';
import { Marker } from 'react-leaflet';
import 'leaflet-rotatedmarker';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { RotationModel } from '../utils';

export interface RotatableMarkerProps extends RotationModel {
  icon: L.Icon;
  eventHandlers?: LeafletEventHandlerFnMap;
}

export function RotatableMarker({
  icon,
  position,
  heading,
  eventHandlers,
  children,
}: PropsWithChildren<RotatableMarkerProps>) {
  const ref = useRef<L.Marker>(null);

  const safeHeading = heading ?? 0;

  useEffect(() => {
    ref.current?.setRotationAngle(safeHeading);
  }, [safeHeading]);

  return (
    <Marker
      ref={ref}
      icon={icon}
      position={position}
      rotationAngle={safeHeading}
      eventHandlers={eventHandlers}
    >
      {children}
    </Marker>
  );
}

export default RotatableMarker;
